import { AsyncWidgetConfigurationNav } from '@jira/navigation-apps__horizontal-nav-csm-widget-configuration/src/AsyncWidgetConfigurationNav.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { widgetAnonymousAccessResource } from '@jira/router-resources__widget-anonymous-access/src/widgetAnonymousAccessResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmExperienceWidgetConfigurationInstallRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceWidgetConfigurationInstallRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';
import { HelpCenterSettingsWidgetConfigurationInstallEntryPoint } from './ui/widget-configuration-install/HelpCenterSettingsWidgetConfigurationInstallEntryPoint.tsx';

export const csmExperienceWidgetConfigurationInstallRouteEntry: Route = createEntry(
	csmExperienceWidgetConfigurationInstallRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.csm-experience-widget-configuration.install',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
			sidebarId: SidebarIdCsmApp,
			horizontal: AsyncWidgetConfigurationNav,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? HelpCenterSettingsWidgetConfigurationInstallEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getCsmExperiencesResources(),
			staticProjectSidebarNavigationResource,
			widgetAnonymousAccessResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
